import {createRouter, createWebHashHistory, createWebHistory, createMemoryHistory} from 'vue-router'
import Home from '../views/Home.vue'
//import Model from '../views/Model.vue'
//import Help from "../views/Help";

const routes = [
    // Einstieg (Ladebildschirm)
    {
        path: '/',
        component: Home,
        meta: {
            title: 'Start'
        }
    },
    // Hilfe
    // {
    //     path: '/help',
    //     component: Help
    //     //component: () => import(/* webpackChunkName: "help" */ '../views/Help.vue')
    // },

    // 3D Modell

    // 3D Modell mit TextBanner
    // {
    //     path: '/titel',
    //     component: () => import(/* webpackChunkName: "textbanner" */ '../views/Titelbild.vue'),
    //     meta: {
    //         title: 'title'
    //     }
    // },

        // 3D Modell mit TextBanner
    // {
    //     path: '/promo1a',
    //     component: () => import(/* webpackChunkName: "textbanner" */ '../views/Promoloop_1a.vue'),
    //     meta: {
    //         title: 'promo1a'
    //     }
    // },

    //         // 3D Modell mit TextBanner
    // {
    //     path: '/promo1b',
    //     component: () => import(/* webpackChunkName: "textbanner" */ '../views/Promoloop_1b.vue'),
    //     meta: {
    //         title: 'promo1b'
    //     }
    // },

    {
        path: '/Alpen',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/010_Alpen.vue'),
        meta: {
            title: 'Alpen'
        }
    },

    {
        path: '/Gletscher',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/020_Gletscher.vue'),
        meta: {
            title: 'Gletscher'
        }
    },

    {
        path: '/Suedlicher_Schneeferner',
        component: () => import(/* webpackChunkName: "infobox" */ '../views/030_Suedlicher_Schneeferner.vue')
    },

    {
        path: '/Schneegrenze',
        component: () => import(/* webpackChunkName: "infoboxcomparison" */ '../views/040_Schneegrenze.vue')
    },

    {
        path: '/Ausblick',
        component: () => import(/* webpackChunkName: "infoboxvideo" */ '../views/050_Ausblick.vue')
        //Der Slide wurde nach ganz hinten verschoben und war ursprünglich mal 010
    },

    // Credits
    {
        path: '/Credits',
        component: () => import(/* webpackChunkName: "credits" */ '../views/060_Credits.vue'),
        meta: {
            title: 'Credits'
        }
    },

];

function getHistory()
{
    if (process.env.VUE_APP_ROUTER_MODE === 'hash')
    {
        return createWebHashHistory();
    }

    if (process.env.VUE_APP_ROUTER_MODE === 'history')
    {
        return createWebHistory();
    }

    return createMemoryHistory();
}

const router = createRouter({
    history: getHistory(),
    base: process.env.BASE_URL,
    routes
});

export default router
